import React from 'react'
import { useAuth } from '../../Context/ContextProvider'

function TabelData() {
    const { quickNews } = useAuth()
    const formatDate = (date) => {
        const newDate = new Date(date)
        const options = { year: 'numeric', month: 'long', day: 'numeric' }
        return newDate.toLocaleDateString('en-US', options)
    }
  return (
    <div className='container'>
        <h2 className='text-center mb-5 mt-5 home_page_section_title'>Latest News</h2>
        <table className='table table-bordered table-striped'>
            <thead>
                <tr>
                    <th>Sr.No</th>
                    <th>Title</th>
                    <th>Date</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {quickNews?.map((item,index)=>(
                    <tr key={item._id}>
                        <td style={{width: '100px'}}>{index+1}</td>
                        <td>{item.title}</td>
                        <td style={{width: '200px'}}>{formatDate(item.createdAt)}</td>
                        <td style={{width: '200px'}}>
                            <button onClick={()=>{
                                if(item.url){
                                    window.open(item.url, '_blank')
                                }
                            }} disabled={item.url ? false : true} style={{backgroundColor: item.url ? '#192c52' : '#192c529c',cursor: item.url ? 'pointer' : 'not-allowed'}} className='btn-theme-table'>View Details
                            </button>
                            </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
  )
}

export default TabelData